<template>
	<div id="statementOfPayables">
		<div class="public-content">
			<div class="form-item-public">
				<el-form inline label-position="left">
					<el-form-item label='应付统计表：'>
						<accounting-period @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
					</el-form-item>
					<el-form-item >
						<el-button size='mini' class='minButton' @click='getTableList'>
							搜索
						</el-button>
					</el-form-item>
					<el-form-item class='right-position'>
						<print-operation
							:formData="printForm"
							:showContinuit="false"
              :showExport="true"
              exportApi="/title/exportReceivableData"
              exportType="1"
						></print-operation>
					</el-form-item>
				</el-form>
			</div>
			<public-table :table='tableData'>
				<template slot='name' slot-scope='props'>
					<el-button type='text' v-text='props.scope.row.name' @click='handleClickDialogShow(props.scope.row)'></el-button>
				</template>
			</public-table>
		</div>
		<statistical-table :showVisible.sync='showVisible' :params='params'></statistical-table>
	</div>
</template>
<script >
	import publicTable from '@/components/publicTable'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import {currencys} from '@/assets/utils/currencyFormat'
	import printOperation from '@/components/print'
	import statisticalTable from '@/components/dialog/statisticalTable'
	export default {
		components: {
			publicTable,
			accountingPeriod,
			printOperation,
			statisticalTable
		},
		data() {
			return {
				isFirstActive: false,
				params: {       // 传入子组件参数
					subjectId: '',      // 科目ID
					auxiliaryId: '',     // 辅助核算ID
					name: '',               // 公司名字
				},
				showVisible: false,
				firstGet: true,    // 第一次请求
				printForm: {        // 打印参数
					data: {
						type: '1',
						yearPeriods: ''
					},
					url: '/createPDF/printCopeWithReceivableService',
					continuityUrl: '/createPDF/printCopeWithReceivableService'
				},
				form: {
					yearPeriods: '',
					type: '1'
				},
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '往来单位',
						value: 'name',
						show: 'template'
					},{
						label: '初期余额',
						value: 'beginningBalance',
						formatter: this.formatter,
						show: 'normal'
					},{
						label: '本期发生',
						formatter: this.formatter,
						value: 'periodOccur',
						show: 'normal',
					},{
						label: '本期支付',
						value: 'periodTakeBack',
						formatter: this.formatter,
						show: 'normal',
					},{
						label: '本年累计',
						value: 'terminal',
						show: 'normal',
						showChild: true,
						children: [{
							label: '发生',
							value: 'yearOccur',
							formatter: this.formatter,
							show: 'normal',
							},{
							label: '支付',
							value: 'yearTakeBack',
							formatter: this.formatter,
							show: 'normal',
						}]
					},{
						label: '余额',
						value: 'balance',
						formatter: this.formatter,
						show: 'normal',
						order: true
					}],
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},

			}
		},
		created() {

		},
		computed : {
			getClickCache() {
				return this.$store.state.loadstatus.isClickCache;
			},
		},
		activated() {
			if(this.getClickCache && this.isFirstActive) {
				this.getTableList();
			}
			this.isFirstActive = true;
		},
		methods: {
			// 公司名称点击事件
			handleClickDialogShow(row) {
				this.params.name = row.name;
				this.params.auxiliaryId = row.auxiliaryId;
				this.params.subjectId = row.subjectId;
				this.showVisible = true;
			},
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}
			},
			// 接收会计期间数据
			defaultTime(data) {
				this.form = Object.assign(this.form,{
					yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				})
				this.printForm.data.yearPeriods = this.form.yearPeriods;
				if(this.firstGet){
					this.getTableList();
					this.firstGet = false;
				}
			},
			// 获取表格数据
			getTableList() {
				try {
					this.tableData.loading = true;

					this.$http.post('title/getCopeWithReceivableService',this.form).then(res=>{
						this.tableData.loading = false;
						if(res && res.data.code == 1) {
							this.tableData.data = res.data.data;
							this.tableData.data.forEach(item=>{
								for (const i in item) {
									if (typeof item[i] === 'number') {
										item[i] = item[i] == 0 ? '' : item[i];
									}
								}
							})
						}
					})
				}catch(e) {
						this.tableData.loading = true;
				}
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/pages/reportForm/statementOfPayables.vue